import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, catchError, map, of, switchMap } from 'rxjs';

import { MemberHubService } from '../services/member-hub.service';
import { VisitStatusTypes } from '@lib/core/models/visit.interface';
import { MembersApiService } from '../services/members-api.service';

import * as MemberHubActions from './member-hub.actions';

export const fetchMemberProfileEffect = createEffect(
  (actions$ = inject(Actions), memberHubService = inject(MemberHubService)): Observable<Action> =>
    actions$.pipe(
      ofType(MemberHubActions.fetchMemberProfile),
      switchMap(action =>
        memberHubService.getMemberProfile(action.memberId).pipe(
          map(memberProfile => MemberHubActions.fetchMemberProfileSuccess({ memberProfile })),
          catchError(() => of(MemberHubActions.fetchMemberProfileFailure({ error: 'Failed to fetch member profile' })))
        )
      )
    ),
  { functional: true }
);

export const fetchMemberFranchiseEffect = createEffect(
  (actions$ = inject(Actions), memberHubService = inject(MemberHubService)): Observable<Action> =>
    actions$.pipe(
      ofType(MemberHubActions.fetchMemberFranchise),
      switchMap(action =>
        memberHubService.getPackageFranchisesByMemberId(action.memberId).pipe(
          map(memberPackage => MemberHubActions.fetchMemberFranchiseSuccess({ franchises: memberPackage })),
          catchError(() => of(MemberHubActions.fetchMemberFranchiseFailure({ error: 'Failed to fetch member franchise' })))
        )
      )
    ),
  { functional: true }
);

export const fetchMemberPackageEffect = createEffect(
  (actions$ = inject(Actions), membersApiService = inject(MembersApiService)): Observable<Action> =>
    actions$.pipe(
      ofType(MemberHubActions.fetchMemberPackage),
      switchMap(action =>
        membersApiService.getMemberPackageByUserId(action.userId).pipe(
          map(memberPackage => MemberHubActions.fetchMemberPackageSuccess({ memberPackage: memberPackage })),
          catchError(() => of(MemberHubActions.fetchMemberPackageFailure({ error: 'Failed to fetch member package' })))
        )
      )
    ),
  { functional: true }
);

export const fetchMemberAppointmentsEffect = createEffect(
  (actions$ = inject(Actions), memberHubService = inject(MemberHubService)): Observable<Action> =>
    actions$.pipe(
      ofType(MemberHubActions.fetchMemberAppointments),
      switchMap(action =>
        memberHubService.searchVisits({
          userId: action.userId,
          page: 1,
          pageSize: 20,
          status: VisitStatusTypes.Done,
          sortBy: 'creationDate',
        }).pipe(
          map(response => MemberHubActions.fetchMemberAppointmentsSuccess({ appointments: response.value || [] })),
          catchError(() => of(MemberHubActions.fetchMemberAppointmentsFailure({ error: 'Failed to fetch member appointments' })))
        )
      )
    ),
  { functional: true }
);